import jonas_happinessbegin_imgSrc from './assets/imgs/Jonas_A0_Rectangle_52_pattern@2x_cut.png';
import embody_withoutyou_imgSrc from './assets/imgs/song-a.jpg';
import embody_lostandfound_imgSrc from './assets/imgs/song-b.jpg';
import embody_dreamin_imgSrc from './assets/imgs/song-c.jpg';
import embody_imissyou_imgSrc from './assets/imgs/embody_A0_Rectangle_50_pattern@2x.png';
import joel_coffee_imgSrc from './assets/imgs/coffee_A0_Path_4_pattern@2x_cut2.png';
import jonas_happinessbegin_mp3 from './assets/mp3/Jonas Brothers - Happiness Begins.mp3';
import embody_withoutyou_mp3 from './assets/mp3/Jonas Brothers - Happiness Begins.mp3';
import embody_lostandfound_mp3 from './assets/mp3/Embody - Without You (feat. Jack Hawitt).mp3';
import embody_dreamin_mp3 from './assets/mp3/Embody - Dreamin (ft. Camden Cox).mp3';
import embody_imissyou_mp3 from './assets/mp3/Embody - I Miss You.mp3';
import joel_coffee_mp3 from './assets/mp3/[Clean] Joel Adams - Coffee.mp3';

export const playList = [
  {
    imgSrc: jonas_happinessbegin_imgSrc,
    musicSrc: jonas_happinessbegin_mp3,
    artist: 'Jonas Brothers',
    musicName: 'Happiness Begins',
    id: 'a'
  },
  {
    imgSrc: embody_imissyou_imgSrc,
    musicSrc: embody_imissyou_mp3,
    artist: 'EMBODY',
    musicName: 'I Miss You',
    id: 'b'
  },
  {
    imgSrc: joel_coffee_imgSrc,
    musicSrc: joel_coffee_mp3,
    artist: 'Joel Adams',
    musicName: 'Coffee',
    id: 'c'
  },
  {
    imgSrc: embody_lostandfound_imgSrc,
    musicSrc: embody_lostandfound_mp3,
    artist: 'EMBODY',
    musicName: 'Lost & Found',
    id: 'd'
  },
  {
    imgSrc: embody_withoutyou_imgSrc,
    musicSrc: embody_withoutyou_mp3,
    artist: 'EMBODY',
    musicName: 'Without You',
    id: 'e'
  },
  {
    imgSrc: embody_dreamin_imgSrc,
    musicSrc: embody_dreamin_mp3,
    artist: 'EMBODY',
    musicName: 'Dreamin',
    id: 'f'
  }
];
